import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useTextRailFilter = () => {
  const { t } = useTranslation(i18nNS.common);

  const filtersMap = {
    vendors: {
      name: t('common:RailFilter.FilterVendors'),
    },
    vendorGroups: {
      name: t('common:RailFilter.VendorsCategory'),
    },
  };

  return [filtersMap];
};

export default useTextRailFilter;
